<template>
  <teleport to="body">
    <div class="modal" v-if="showModal" @click.self.prevent="showModal != showModal">
      <div class="wrapper">
        <font-awesome-icon icon="fa-xmark" class="exit" @click.stop.prevent="closed" />
        <section class="user">
          <div class="user-info">
            <h2>{{ user.value.fname }} {{ user.value.lname }}</h2>
            <h3>{{ user.value.email }}</h3>
            <h4>No. orders: {{ user.key }}</h4>
          </div>
          <!-- <h4>User Orders:</h4> -->
          <div class="buttons">
            <button @click.stop.prevent="orders(false)">previous</button>
            <button @click.stop.prevent="orders(true)">next</button>
          </div>
          <!-- {{ orderData }} -->
          <div class="user-orders">
            <ul>
              <li v-for="order in orderData" :key="order" @click.stop.prevent="expandOrder(order.docs[0].ok._id)">
                <span>{{ new Date(order.docs[0].ok.events.created_at).toDateString() }}</span>
                <span class="float" v-if="order.docs[0].ok.total"><CurrencyFormatter :value="order.docs[0].ok.total" :currency="companySettings.currency" /></span>
                <span class="float" v-else><CurrencyFormatter :value="oldDocTypeCalc(order.docs)" :currency="companySettings.currency" /></span>
                <div class="details" :id="order.docs[0].ok._id">
                  <ul class="orders">
                    <li v-for="item in order.docs[0].ok.products" :key="item" class="item">
                      <span v-if="item.price">{{ item.name }}</span>
                      <span v-else >{{ item.fields.product_name}}</span>
                      <span v-if="item.price" class="float"><CurrencyFormatter :value="item.price" :currency="companySettings.currency" /></span>
                      <span v-else class="float"><CurrencyFormatter :value="parseFloat(item.fields._line_total)" :currency="companySettings.currency" /></span>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@monolith/helpers";
import { CurrencyFormatter } from "@monolith/components";
export default {
  name: "UserOrderModal",
  data() {
    return {
      showModal: false,
      currentPag: 0,
      userOrders: [],
      orderData: [],
      showDetails: false,
    };
  },
  emits: ["closeModal"],
  components: {
    CurrencyFormatter,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },

  watch: {
    async open() {
      if (!this.open) {
        this.showModal = false;
        return;
      }
      this.showModal = true;
      this.orders(true);
    },
  },

  methods: {
    expandOrder(id) {
      document.getElementById(id).classList.toggle("details");
    },

    closed() {
      this.$emit("closeModal");
      this.currentPag = 0;
      this.showModal = false;
    },

    async getOrders() {
      let userOrders = [];
      this.userOrders.map((id) => userOrders.push({ id: id }));
      let result = await api.get_user_orders({ docs: userOrders });
      this.orderData = result.results;
    },

    orders(pagination) {
      let orders = this.user.value.orders.toReversed();
      this.currentPag = pagination ? (this.currentPag += 10) : (this.currentPag -= 10);
      this.userOrders = pagination ? orders.slice(this.currentPag, this.currentPag + 10) : orders.slice(this.currentPag - 10, this.currentPag);
      this.getOrders();
    },

    oldDocTypeCalc(doc) {
      return doc[0].ok.items.reduce((acc, item) => acc += parseFloat(item.fields._unit_price), 0);
    },
  },
  computed: {
    ...mapGetters({
      sites: "sites",
      companyName: "companyName",
      companySettings: "companySettings",
    }),
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.wrapper {
  .user {
    color: var(--text-colour);
    max-height: 80vh;

    .buttons {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: 0;
    }
    button {
      width: 100%;
      margin: 1rem;
      padding: 0.5rem;
      background-color: var(--action-colour);
      color: var(--secondary-text-colour);
      border-radius: 5px;
      border: none;
      box-shadow: var(--box-shadow);
      text-transform: capitalize;
      cursor: pointer;
    }
    .user-orders {
      display: flex;
      align-items: center;
      justify-content: center;
      ul {
        padding-inline-start: 0;
      }
      li {
        list-style: none;
        box-shadow: var(--box-shadow);
        padding: 1rem;
        margin: 1rem;
        border-radius: 10px;
        background: var(--primary-colour);
        width: 20rem;
        cursor: pointer;
        .float {
          float: right;
        }
        .details {
          display: none;
        }
        .orders {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 1rem 0 0 0;
          .item {
            padding: 1rem 0.5rem;
            margin: 0.5rem;
            color: var(--action-colour);
          }
        }
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .user {
    .buttons {
      justify-self: center;
      button {
        width: 5rem;
      }
    }
    .user-orders {
      ul {
        margin: auto;
        li {
          max-width: 100%;
          width: 80% !important;
          min-width: 80%;
          margin-left: 0.5rem !important;
        }
      }
    }
  }
}
</style>
